import { useNavigate } from "react-router-dom";
import ErrorImage from "../assets/error/Internal-server.svg";
import Ellipse1 from "../assets/error/Ellipse 24.svg";
import Ellipse2 from "../assets/error/Ellipse 22.svg";
import Ellipse3 from "../assets/error/Ellipse 21.svg";
import Ellipse4 from "../assets/error/Ellipse 23.svg";

function NotFoundPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="h-screen w-full bg-[#D8DEEF] font-alexandria flex items-center justify-center p-4">
              <img
        src={Ellipse1}
        alt="Ellipse 1"
        className="absolute bottom-0 left-0 w-[200px] sm:w-[250px] md:w-[380px] z-10"
      />
      <img
        src={Ellipse4}
        alt="Ellipse 4"
        className="absolute bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[400px] z-10 opacity-[60%]"
      />
      <img
        src={Ellipse2}
        alt="Ellipse 2"
        className="absolute bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[250px] z-10"
      />
      <img
        src={Ellipse3}
        alt="Ellipse 2"
        className="absolute  bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[250px] opacity-[60%] z-10"
      />

      <div className="bg-white rounded-[20px]  border border-[#E5E5E5] w-[950px] h-auto md:h-[670px] flex flex-col md:flex-row items-center justify-between p-10 sm:p-16 md:px-[125px] md:py-[140px] relative z-10">
        <div className="text-left space-y-[40px] md:space-y-[70px]">
          <div className="flex flex-col items-start gap-2 text-transparent bg-clip-text bg-gradient-to-b from-[#4772F1] to-[#873FE2]">
            <h2 className="text-[30px] sm:text-[36px] md:text-[40px] lg:text-[50px] font-medium text-transparent leading-[125%]">
              Internal Server
            </h2>
            <h3 className="text-[30px] sm:text-[36px] md:text-[40px] lg:text-[50px] font-medium text-transparent leading-[125%]">
              Error (500)
            </h3>
          </div>
          <p className="text-[#4772F1] text-[16px] sm:text-[18px] md:text-[20px] font-normal max-w-[322px] md:max-w-[355px] leading-[125%]">
            Something went wrong on our end. Please try again later.
          </p>
          <button
            onClick={handleGoHome}
            className="mt-[30px] h-[48px] sm:h-[55px] text-[15px] sm:text-[16px] md:text-[18px] font-semibold px-6 py-2 bg-[#4772F1] w-full sm:w-[290px] md:w-[315px] border-[2px] border-[#4772F1] text-white rounded-[8px] hover:bg-[#3a2ecc] transition"
          >
            Back to Dashboard
          </button>
        </div>

        <img
          src={ErrorImage}
          alt="Internal server error illustration"
          className="w-[180px] h-[180px] sm:w-[228px] sm:h-[228px] mt-10 md:mt-0"
        />
      </div>
    </div>
  );
}

export default NotFoundPage;
